export default "__VITE_ASSET__de02e109__"